/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage($input: DeleteMessageInput!) {
    deleteMessage(input: $input) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
